import React, { useEffect, useState } from 'react';
import './Cookies.css';

const Cookies = ({ onPrivacyClick }) => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    } else if (consent === 'all') {
      loadElfsight();
    }
  }, []);

  const acceptEssential = () => {
    localStorage.setItem('cookieConsent', 'essential');
    setShowBanner(false);
  };

  const acceptAll = () => {
    localStorage.setItem('cookieConsent', 'all');
    setShowBanner(false);
    loadElfsight();
  };

  const loadElfsight = () => {
    const script = document.createElement('script');
    script.src = 'https://apps.elfsight.com/p/platform.js';
    script.defer = true;
    document.body.appendChild(script);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-live="polite" aria-label="Informativa sui cookie">
      <p>
        Usiamo cookie essenziali e, con il tuo consenso, cookie di terze parti (es. Elfsight).
        <br />
        <button className="privacy-link" onClick={onPrivacyClick} aria-label="Leggi la nostra Privacy Policy">
          Leggi la nostra Privacy Policy
        </button>.
      </p>
      <div className="cookie-buttons">
        <button className="btn-outline" onClick={acceptEssential} aria-label="Accetta solo i cookie essenziali">
          Solo essenziali
        </button>
        <button onClick={acceptAll} aria-label="Accetta tutti i cookie">
          Accetta tutti
        </button>
      </div>
    </div>

  );
};

export default Cookies;
